<template>
  <div class="prequiz">
    <component :is="activeView" />
  </div>
</template>

<script>
import Question from "./Question";
import Results from "./Results";
export default {
  components: {
    Question,
    Results
  },
  mounted()
  {
    this.$store.dispatch('startGame');
  },
  computed: {
    activeView() {
      let question = this.$store.state.question;

      // Get the match object from the store
      const results = this.$store.state.results;
      // Show the question if the question is open, and results if not

      if (results)
      {
        return "Results";
      }else
      {
        //return question ? "Slide": "Question";
        return "Question";
      }

    },
  }
};
</script>
